<template>
  <Header @change-password="handleChangePassword" />
  <div class="wrapper">
    <router-view v-if="!isLoading" />
    <Loader v-else class="loader-default" />
  </div>
  <div id="modals"></div>
  <Error v-if="error" />
  <ModalSuccess v-if="success" />
  <PasswordExpirationNotification @change-password="handleChangePassword" />
  <ChangePasswordModal
    v-if="isChangePasswordModalVisible"
    @close="isChangePasswordModalVisible = false"
  />
</template>

<script setup>
import Error from '@/components/Error.vue'
import Header from '@/components/Header.vue'
import ModalSuccess from '@/components/ModalSuccess.vue'
import Loader from '@/components/Loader.vue'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import PasswordExpirationNotification from '@/components/PasswordExpirationNotification.vue'
import ChangePasswordModal from '@/components/ChangePasswordModal.vue'

const store = useStore()
const error = computed(() => store.state.error)
const success = computed(() => store.state.success)
const isChangePasswordModalVisible = ref(false)
const isLoading = computed(() => store.state.isLoading)

const handleChangePassword = () => {
  isChangePasswordModalVisible.value = true
}
</script>

<style lang="scss">
.wrapper {
  padding-top: 40px;
  padding-bottom: 40px;
  @include mobile {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  &__loader {
    display: flex;
    margin: 0 auto;
    max-height: 200px;
  }
}
</style>
